var map = {
	"./add_85x85.png": 5502,
	"./add_gray_85x85.png": 2900,
	"./agenda_85x85.png": 7481,
	"./archive_85x85.png": 9297,
	"./assign_notselected_85x85.png": 1291,
	"./assign_selected_85x85.png": 9766,
	"./case_85x85.png": 2957,
	"./comment_or_report_85x85.png": 657,
	"./dacca_85x85.png": 9027,
	"./dacca_with_calculation_85x85.png": 1140,
	"./dearchive_85x85.png": 6182,
	"./expertise_attachment_85x85.png": 3622,
	"./honorary_note_85x85.png": 7682,
	"./images_85x85.png": 851,
	"./insured_person_85x85.png": 4627,
	"./other_attachments_85x85.png": 2650,
	"./overview_85x85.png": 7816,
	"./policy_85x85.png": 799,
	"./remove_85x85.png": 1933,
	"./retrieve_dacca_85x85.png": 4684,
	"./retrieve_dacca_green_85x85.png": 4776,
	"./retrieve_revidea_85x85.png": 5478,
	"./rim_85x85.png": 3419,
	"./save_85x85.png": 7462,
	"./search_85x85.png": 6353,
	"./search_filtered_85x85.png": 9069,
	"./send_85x85.png": 2879,
	"./svs_85x85.png": 6041,
	"./uploaded_85x85.png": 5045
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9984;